import { type CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

import { uiBackgroundColor } from "@/view/utils/userContentUIStyles/userContentUIStyles.style";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints } = constants;
const { fontSize } = typographyStyles;
const { sm } = breakpoints.BreakpointNames;

export const rootCss = (uiType: string): CSSObject => ({
  ...fontSize.textS,
  background: uiBackgroundColor(uiType),
  display: "flex",
  justifyContent: "center",
  paddingTop: "1rem",
  [mediaQuery.upTo(sm)]: {
    paddingTop: "0",
  },
});

export const levelAlertPlaceholder = (uiType: string): CSSObject => ({
  background: uiBackgroundColor(uiType),
  // We're adding a height to an empty div here
  // so the page doesn't jump when read aloud is triggered
  // and both the primary actions and level alert are hidden.
  height: "2.375rem",
  [mediaQuery.upTo(sm)]: {
    height: "1.375rem",
  },
});
